import {
  coreKeyMetricsConfig,
  keyMetricObj,
} from '@op/pages/CustomizedReports/WeeklyReport/Overview/constants';
import { DownloadConfigInfoType } from '../types';
import { ratioReduce } from '../renderHelper';

export const WeeklyReportOverviewKeyMetrics: DownloadConfigInfoType = {
  columns: () => {
    return coreKeyMetricsConfig.map(({ key, text, header, isPercentage }) => {
      const item: any = {
        key,
        header: header || text,
        cellFormat: !isPercentage,
      };

      // 判断列是否有占比标识，如果有，就直接将列设置为占比，并且关闭行格式化
      if (isPercentage) {
        item.numFmt = '0.00%';
        item.renderHelper = [ratioReduce()];
      }

      return item;
    });
  },
  dealWithDataFunc: ({ data }) => {
    const list = data.map((item: any) => {
      const { metric } = item;
      const { format, isPercentage, downloadText, text } = keyMetricObj[metric];
      const obj: any = {};
      coreKeyMetricsConfig.forEach(metricConfig => {
        const {
          key,
          format: metricFormat,
          isPercentage: metricIsPercentage,
          isText,
        } = metricConfig;
        const func = metricFormat || format;
        const value = item[key];
        if (isText) {
          obj[key] = downloadText || text;
        } else {
          // 如果列是占比，或者行不是占比，那么就不要进行func处理
          obj[key] = metricIsPercentage || !isPercentage ? value : func(value);
        }
      });
      return obj;
    });
    return list;
  },
};
